import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class GatePassService {
  static getGatePassList = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.goodsRemovalControl.goodsRemovalControlUrl,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getGatePassById = async (id: number | string) => {
    try {
      return await Http.get(
        `${API_URLs.goodsRemovalControl.goodsRemovalControlUrl}/${id}`
      );
    } catch (error) {
      return error;
    }
  };
}
